import { updateRelationshipReferences } from 'shared/services/backend-api';
import { IDPrefixes } from 'shared/types/id';
import { Relationship } from 'shared/types/relationship';
import { Task } from 'shared/types/task';
import { createPrefixId } from 'shared/utils/prefix-id';

export const updateLinkedRelationships = (
  oldTask: Task,
  task: Task,
  relationships: Relationship[],
) => {
  const taskRelationshipId = createPrefixId(oldTask.id, IDPrefixes.Task);
  const linkedRelationships = relationships.filter((relationship) =>
    relationship.references.includes(taskRelationshipId),
  );

  if (!linkedRelationships.length) {
    return;
  }

  updateRelationshipReferences(
    linkedRelationships.map((relationship) => ({
      id: relationship.id,
      references: [
        ...relationship.references,
        createPrefixId(task.id, IDPrefixes.Task),
      ],
    })),
  );
};
